export default function MemberCard({ image, name, title, description }) {
  return (
    <div className='drop-shadow-lg flex rounded-2xl max-w-md md:max-w-xl overflow-hidden mx-2 h-full'>
      <img src={image} alt={'temp'} className='object-cover w-[140px] md:w-[200px] h-[240px] md:h-[280px]' />

      <div className='p-4 md:p-8 text-left bg-white'>
        <h2 className='h3 mb-1 text-lg md:text-2xl font-bold'>{name}</h2>
        <p className='text-sm md:text-lg font-medium mb-4 font-montreal'>{title}</p>
        <p className='font-montreal text-xs md:text-sm'>{description}</p>
      </div>
    </div>
  );
}
